import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Tenants/Table";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import {
  FieldWrapper,
  InputGroup,
  Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import EditTenantsModel from "../../Components/Tenants/EditTenants";
import ViewDetailModel from "../../Components/Tenants/ViewDetail";
import Kyc from "../../Components/Tenants/Kyc";
import UploadDocument from "../../Components/Tenants/UploadDocument";
import TenantDelete from "../../Components/Tenants/TenanatsDeleteModal";
import moment from "moment";
import { useParams } from 'react-router-dom';
const Tenants = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("mobile");
  const [editUser, setEditUser] = useState(false);
  const [tenantDeleteModal, setTenantDeleteModal] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [openKYCModel, setOpenKYCModel] = useState(false);
  const [uploadDocument, setUploadDocument] = useState(false);
  //const { id } = useParams();

  const [apiData, setApiData] = useState();
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(90, "days").format("YYYY-MM-DD")
  );

  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const { t } = useTranslation();

  const initialValues = {
    name: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(90, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const fetchFunction = async () => {
    const body = new FormData();
    body.append("filterType", filter);
    body.append("filterValue", filterValue);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    return await axios.post(`${Config.apiUrl}/gettenants`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getTenantsSuccess = (res) => {
    if (res.data.status == "NOK" || res.data.data == false) error = true;
    setApiData(res.data);
  };

  const getTenantsError = (res) => { };

  const {
    isLoading: isLoading,
    mutate: getTenantsMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getTenantsSuccess,
    onError: getTenantsError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getTenantsMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [filterValue, startDate, endDate]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getTenantsMutate();
  };
  const ChangeHandler = (e) => {
    setFilterValue(e.target.value);
  };

  //------- Edit Single Entry -------
  const EditTenantsFunction = async (values) => {
    const body = new FormData();
    body.append("tenantId", values.tenantId);
    body.append("name", values.name);
    body.append("mobile", values.mobile);
    body.append("status", values.status);
    body.append("occupation", values.occupation);
    body.append("gender", values.gender);
    body.append("email", values.email);
    body.append("kycStatus", values.kycStatus);
    body.append("moveInDate", values.moveInDate);
    body.append("agreementStartDate", values.agreementStartDate);
    body.append("rentalCycle", values.rentalCycle);

    return await axios.post(`${Config.apiUrl}/edittenant`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onEditEntrySuccess = (data) => {
    if (data?.data?.status == "OK") {
      toast.success(data?.data?.msg || "Success");
      setApiData(data.data);
      getTenantsMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setEditUser(false);
  };

  const onEditEntryError = (data) => {
    setEditUser(false);
    setSelectedData("");
    toast.error(data?.data?.msg || "An Error Occured");
  };

  const { isLoading: editEntryLoading, mutate: editTenantsMutate } =
    useMutation(EditTenantsFunction, {
      onSuccess: onEditEntrySuccess,
      onError: onEditEntryError,
    });


  // --------Upload Document---------
  const uploadDocumentFunction = async (values) => {
    console.log("documents values ", values);
    const formData = new FormData();
    const docs = [];
    if(values.tenantDocumentImage){
      docs.push(values.tenantDocumentImage);
    }
    if(values.tenantDocumentBackImage){
      docs.push(values.tenantDocumentBackImage);
    }
    console.log("docs",docs);
    formData.append("tenantId",values.id);
    formData.append("type",values.type);
    formData.append("files[0]", values.tenantDocumentImage);
    formData.append("files[1]", values.tenantDocumentBackImage);
  
    return await axios.post(`${Config.apiUrl}/uploaddocument`, formData, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "multipart/form-data",
      },
    });
  };

  const onUploadDocumentSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Document uploaded successfully!");
      // apiData((prevData) =>
      //   prevData.map((owner) =>
      //     owner.id === selectedData.id
      //       ? { ...owner, documentPath: data.data.documentPath }
      //       : owner
      //   )
      // );
    } else {
      toast.error(data?.data?.msg || "An error occurred.");
    }
    setUploadDocument(false);
    setSelectedData("");
  };

  const onUploadDocumentError = (error) => {
    toast.error(error?.response?.data?.msg || "An error occurred.");
    setUploadDocument(false);
  };
  const { isLoading: uploadDocumentLoading, mutate: uploadDocumentMutate } =
    useMutation(uploadDocumentFunction, {
      onSuccess: onUploadDocumentSuccess,
      onError: onUploadDocumentError,
    });

    const deleteTenant = async ({occupancyId}) => {
      const body = new FormData();
      // body.append("tenantId", tenantId); //dec 30 change with occupancyId changed by anurag
      body.append("occupancyId", occupancyId);
      console.log("hi am dtaat:::::",data.data)
      return await axios.post(`${Config.apiUrl}/deletetenant`, body, {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      });
    };
    const onDeleteTenantSuccess = (data) => {
      if (data?.data?.status === "OK") {
        toast.success(data?.data?.msg || "Deleted Successfully");
        setTenantDeleteModal(false);
        getTenantsMutate();
      }
    };
  
    const onDeleteTenantError = (res) => { };
  
    const { isLoading: isdeleteTenantLoading, mutate: deleteTenantMutate } =
      useMutation(deleteTenant, {
        onSuccess: onDeleteTenantSuccess,
        onError: onDeleteTenantError,
      });
  
  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        {/* <Page> */}
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{t("Tenants")}</Title>
              <Underline />
            </div>
          </div>

          <div className="flex w-full justify-between items-center">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              setFilter={setFilter}
              setFilterValue={setFilterValue}
              ChangeHandler={ChangeHandler}
              filterValue={filterValue}
              filter={filter}
              t={t}
            />
          </div>

          {editUser && (
            <EditTenantsModel
              editTenantsMutate={editTenantsMutate}
              editEntryLoading={editEntryLoading}
              setEditUser={setEditUser}
              data={data?.data}
              selectedData={selectedData}
            />
          )}

          {viewDetail && (
            <ViewDetailModel
              setViewDetail={setViewDetail}
              selectedData={selectedData}
            />
          )}

          {openKYCModel && (
            <Kyc
              setOpenKYCModel={setOpenKYCModel}
              selectedData={selectedData}
            />
          )}
          {uploadDocument && (
            <UploadDocument
              uploadDocumentMutate={uploadDocumentMutate}
              uploadDocumentLoading={uploadDocumentLoading}
              setUploadDocument={setUploadDocument}
              selectedData={selectedData}
              data={data?.data}
            />
          )}
        {tenantDeleteModal &&(
          <TenantDelete
          deleteMutate={deleteTenantMutate}
          isdeleteTenantLoading={isdeleteTenantLoading}
          setTenantDeleteModal={setTenantDeleteModal}
          selectedData={selectedData}
          />
        ) }

          {!error && !isLoading && data && (
            <TableWrapper>
              <Table
                ApiData={error ? [] : apiData.data}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                setEditUser={setEditUser}
                setViewDetail={setViewDetail}
                userType={user.userType}
                setOpenKYCModel={setOpenKYCModel}
                setUploadDocument={setUploadDocument}
                 setTenantDeleteModal={setTenantDeleteModal}
                // setDelete={setDelete}
              />
              {(error || data?.data?.msg == "No data found") && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
          {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  filter,
  setFilter,
  setFilterValue,
  filterValue,
  ChangeHandler,
  t,
}) => {
  const today = moment().format("YYYY-MM-DD");
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form className="w-full">
        <FilterContainer>
          <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
            <div className="flex items-end gap-2">
              <InputGroup className="max-w-[130px]">
                <Label htmlFor="startDate">{t("Start_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="startDate"
                    id="startDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>

              <InputGroup className="max-w-[130px]">
                <Label htmlFor="endDate">{t("End_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="endDate"
                    id="endDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>
            </div>
            <ApplyBtn disabled={InitialLoading} type="submit">
              {t("Date_filter")}
            </ApplyBtn>
          </div>

          <div className="flex gap-4 items-end">
            {filter !== "status" && filter !== "paystatus" ? (
              <InputGroup className="max-w-[200px]">
                <Label htmlFor="filterVal">{("")}</Label>
                <Field
                  placeholder="Search..."
                  type="text"
                  name="filterVal"
                  id="filterVal"
                  inputMode={filter === "mobile" ? "numeric" : "text"}
                  maxLength={filter === "mobile" ? "10" : undefined}
                  pattern={filter === "mobile" ? "[0-9]*" : undefined}
                  // className=""
                  value={filterValue}
                  onChange={(e) => {
                    if (filter === "mobile" || filter === "occupancyId") {
                      const value = e.target.value;
                      // Restrict input to digits only, up to 10 characters
                      if (/^\d{0,10}$/.test(value)) {
                        ChangeHandler(e);
                      }
                    } else {
                      ChangeHandler(e);
                    }
                  }}
                  className="ml-1 border border-slate-300 rounded-md px-4 focus:ring-1 focus:ring-primary-color focus:border-primary-color py-2"
                />
              </InputGroup>
            ) : filter === "status" ? (
              <InputGroup
                className="min-w-[120px]"
                style={{ flexBasis: "content" }}
              >
                <Label htmlFor="filter">{t("Select")}</Label>
                <Select
                  autoComplete="off"
                  className="px-2 bg-transparent text-sm border-none"
                  style={{ height: "40px" }}
                  value={filterValue}
                  onChange={ChangeHandler}
                >
                  <MenuItem value="" disabled>
                    {t("Select Status")}
                  </MenuItem>
                  <MenuItem value="1">{t("Unverified")}</MenuItem>
                  <MenuItem value="2">{t("Vacant")}</MenuItem>
                  <MenuItem value="3">{t("Linked")}</MenuItem>
                  <MenuItem value="4">{t("Requested")}</MenuItem>
                  <MenuItem value="5">{t("Occupied")}</MenuItem>
                  <MenuItem value="6">{t("Moving Out")}</MenuItem>
                  <MenuItem value="7">{t("Reserved")}</MenuItem>
		   /* <MenuItem value="1">{t("Pending")}</MenuItem>
                  <MenuItem value="2">{t("Requested")}</MenuItem>
                  <MenuItem value="3">{t("Occupied")}</MenuItem>
                  <MenuItem value="4">{t("Moving Out")}</MenuItem>
                  <MenuItem value="5">{t("Reserved")}</MenuItem>*/
                </Select>
              </InputGroup>
            ) : null}

            <InputGroup
              className="min-w-[120px]"
              style={{ flexBasis: "content" }}
            >
              <Label htmlFor="filter">{t("Search By")}</Label>

              <Select
                autoComplete="off"
                className="w-24 px-2 bg-transparent text-sm border-none"
                style={{ height: "40px" }}
                value={filter}
                onChange={(e) => {
                  setFilter(e.target.value);
                  setFilterValue("");
                }}
              >
                <MenuItem value="mobile">Phone</MenuItem>
                <MenuItem value="name">Name</MenuItem>
                <MenuItem value="status">Status</MenuItem>
                <MenuItem value="propName">Property</MenuItem>
              </Select>
            </InputGroup>
          </div>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`my-10 border  bg-white rounded-md `;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;

const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;

export default Tenants;
